import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import { FormLabel } from '@material-ui/core';
import Firestore from '../../api/firebase/Firestore';
import SessionHelper from '../../helper/SessionHelper';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class CalendarEventReport extends Component {

    state = {
        loadingModal: true,
        studentDocs: [],
        teacherDocs: [],
        courtDocs: [],
        users: [],
        allUsers: true,
        teachers: [],
        allTeachers: true,
        courts: [],
        allCourts: true,
        showLesson: true,
        showCourtRent: true,
        showTournamentMatch: true,
        showExperimentalLesson: true,
        showPrivateLesson: true,
        showDayUse: true,
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs.length) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this, 'studentDocs', true);
            }
        }

        this.setState({ loadingModal: false });
    }

    async getReportDocs() {

        let docs = [];
        let allEvents = [];

        let teachers = this.state.allTeachers ? this.state.teacherDocs : this.state.teachers;
        let teacherDocs = [];

        let users = this.state.allUsers ? this.state.studentDocs : this.state.users;
        let userDocs = [];

        let courts = this.state.allCourts ? this.state.courtDocs : this.state.courts;
        let courtDocs = [];

        teachers.forEach((teacher, key) => {

            let teacherDoc = teacher;

            if (!this.state.allTeachers) {

                teacherDoc = this.state.teacherDocs.find(item => item.id === teacher);
            }

            teacherDocs.push(teacherDoc);
        });

        users.forEach((user, key) => {

            let userDoc = user;

            if (!this.state.allUsers) {

                userDoc = this.state.studentDocs.find(item => item.id === user);
            }

            userDocs.push(userDoc);
        });

        courts.forEach((court, key) => {

            let courtDoc = court;

            if (!this.state.allCourts) {

                courtDoc = this.state.courtDocs.find(item => item.id === court);
            }

            courtDocs.push(courtDoc);
        });

        if (this.state.showLesson) {

            let query = await Firestore.customQuery('lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula',
                events: query.docs,
            });
        }

        if (this.state.showCourtRent) {

            let query = await Firestore.customQuery('court_rent').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aluguel de Quadra',
                events: query.docs,
            });
        }

        if (this.state.showTournamentMatch) {

            let query = await Firestore.customQuery('tournament_event').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
           
            allEvents.push({
                type: 'Partida de Torneio',
                events: query.docs,
            });
        }

        if (this.state.showExperimentalLesson) {

            let query = await Firestore.customQuery('experimental_lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula Experimental',
                events: query.docs,
            });
        }

        if (this.state.showPrivateLesson) {

            let query = await Firestore.customQuery('private_lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula Avulsa',
                events: query.docs,
            });
        }

        if (this.state.showDayUse) {

            let query = await Firestore.customQuery('day_use').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Day Use',
                events: query.docs,
            });
        }

        for (let eventType of allEvents) {
         
            let type = eventType.type;
            let events = eventType.events;

            for (let doc of events) {

                let findTeacher = false;
                let findStudent = false;
                let findCourt = false;

                let event = { ...doc.data(), id: doc.id };
            
                let userNames = [];
                let idUsers = [];
    
                if (event.id_students) { idUsers = event.id_students };
                if (event.participants) { idUsers = event.participants };
                if (event.id_players) { idUsers = event.id_players };
                if (event.id_user) { idUsers = [ event.id_user ] };

                idUsers.forEach((user, key) => {
    
                    let doc = userDocs.find(item => item.id === user);

                    if (doc) {
                        
                        userNames.push(ReportHelper.treatName(doc.name));
                        findStudent = true;
                    }
                });

                if (event.manual_info && event.manual_info.name) { userNames.push(ReportHelper.treatName(event.manual_info.name)) };
    
                let courtNames = [];
                let idCourts = [];

                if (event.id_courts) { idCourts = event.id_courts };
                if (event.id_court) { idCourts = [ event.id_court ] };

                idCourts.forEach((court, key) => {
    
                    let doc = courtDocs.find(item => item.id === court);
                    
                    if (doc) {

                        courtNames.push(doc.name)
                        findCourt = true;

                    } else {

                        userNames.push('Quadra Desconhecida');
                    }
                });

                let order = 'Sem Pedido';

                if (event.id_order) {

                    let query = await Firestore.getDoc('order', event.id_order);
                    if (query.exists) { order = query.data().title };
                }

                let teacher = 'Sem Professor';

                if (event.id_teacher) {

                    let doc = teacherDocs.find(item => item.id === event.id_teacher);

                    if (doc) {
                        
                        teacher = ReportHelper.treatName(doc.name);
                        findTeacher = true;
                    }
                }

                if (findCourt && (event.id_teacher && findTeacher || !event.id_teacher && this.state.allTeachers) && findStudent) {

                    docs.push({
                        date: `${moment(event.start.toDate()).format('DD/MM/YYYY HH:mm')} ~ ${moment(event.end.toDate()).format('HH:mm')}`,
                        court: courtNames.join(', '),
                        students: userNames.join(', '),
                        type: type,
                        order: order,
                        teacher: teacher,
                    });
                }
            }
        }

        docs.sort((a, b) => {

            return a.date > b.date;
        });

        return docs;
    }

    async print() {

        this.setState({ loadingModal: true });

        let docs = await this.getReportDocs();
        let name = `Agenda de Eventos - ${SessionHelper.getData().company.name}`;
        let subtitle = `De ${moment(this.state.start).format('DD/MM/YYYY HH:mm')} Até ${moment(this.state.end).format('DD/MM/YYYY HH:mm')}`;
        let report = await ReportHelper.createReport(name, 5, subtitle);

        report = await ReportHelper.createColumns(report, docs, [
            { name: 'Tipo', width: 13, getText: (doc) => doc.type },
            { name: 'Data', width: 47, getText: (doc) => doc.date },
            { name: 'Quadra', width: 92, getText: (doc) => ReportHelper.cutName(doc.court, 20) },
            { name: 'Aluno/Cliente', width: 135, getText: (doc) => ReportHelper.cutName(doc.students, 34) },
        ]);

        ReportHelper.print(report, this.state.output, this.state.format);

        this.setState({ loadingModal: false });
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    renderModal() {

        return (

            <div>
                <IosSwitch fullWidth label={'Todos os Professores'} checked={this.state.allTeachers} onChange={(e) => { this.setState({ allTeachers: e, teachers: [] }) }} />
                { !this.state.allTeachers ? ReportHelper.renderTeacherSelection(this, this.state.teacherDocs, 'teachers') : null }

                <IosSwitch fullWidth label={'Todos os Alunos'} checked={this.state.allUsers} onChange={(e) => { this.setState({ allUsers: e, users: [] }) }} />
                { !this.state.allUsers ? ReportHelper.renderUserSelection(this, this.state.studentDocs, 'users') : null }

                <IosSwitch fullWidth label={'Todas as Quadras'} checked={this.state.allCourts} onChange={(e) => { this.setState({ allCourts: e, courts: [] }) }} />
                { !this.state.allCourts ? ReportHelper.renderCourtSelection(this, this.state.courtDocs, 'courts') : null }

                { ReportHelper.renderPeriodSelection(this, 'start', 'end', 'dd/MM/yyyy HH:mm') }
                
                <FormLabel style={{ marginTop: 18, fontWeight: '800', marginBottom: 10 }} component="legend">Exibir</FormLabel>
                <IosSwitch fullWidth label={'Aulas'} checked={this.state.showLesson} onChange={(e) => { this.setState({ showLesson: e }) }} />
                <IosSwitch fullWidth label={'Aluguel de Quadra'} checked={this.state.showCourtRent} onChange={(e) => { this.setState({ showCourtRent: e }) }} />
                <IosSwitch fullWidth label={'Partida de Torneio'} checked={this.state.showTournamentMatch} onChange={(e) => { this.setState({ showTournamentMatch: e }) }} />
                <IosSwitch fullWidth label={'Aula Experimental'} checked={this.state.showExperimentalLesson} onChange={(e) => { this.setState({ showExperimentalLesson: e }) }} />
                <IosSwitch fullWidth label={'Aula Avulsa'} checked={this.state.showPrivateLesson} onChange={(e) => { this.setState({ showPrivateLesson: e }) }} />
                <IosSwitch fullWidth label={'Day Use'} checked={this.state.showDayUse} onChange={(e) => { this.setState({ showDayUse: e }) }} />
                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}